import { Injectable } from '@angular/core';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { BaseDataResponse, BaseEntitiesResponse, Log, LogParams} from '@m4u-angular/base/entities/BaseEntities';
import { Observable } from 'rxjs';
import { APIGatewayService } from '../gateway/APIGateway.service';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';

@Injectable()
export class LogEndpoint extends BaseEndpointCRUD<Log> {
    constructor(api: APIGatewayService) {
        super('Log', api);
    }
    
    public ListEx(Params: LogParams, options: DataLoadOptions): Observable<BaseEntitiesResponse<Log>> {
        return this.api.ExecutePostAction(this.ControllerName, 'ListEx', Params, options?.GetLoadOptions());
    }

    public GetObjectTypes(): Observable<BaseDataResponse<string[]>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetObjectTypes');
    }
}